import axios from "redaxios"

/*
 * Place Result API: https://www.here.com/docs/bundle/geocoding-and-search-api-developer-guide/page/topics/result-types-place.html
 * Address Result API: https://www.here.com/docs/bundle/geocoding-and-search-api-developer-guide/page/topics/result-types-address.html
 */

const API_KEY = import.meta.env.VITE_HERE_API_KEY
const BASE_URL = new URL("https://discover.search.hereapi.com/v1/discover")

type DiscoverResult = {
	items: DiscoverResultItem[]
}

export type DiscoverResultItem = {
	id: string
	title: string
	resultType: ResultType
	address: DiscoverAddress
	position: {
		lat: number
		lng: number
	}
	mapView: {
		east: number
		west: number
		north: number
		south: number
	}
}

/* See:
 * https://www.here.com/docs/bundle/geocoding-and-search-api-developer-guide/page/topics/result-types.html
 * for the official list of result types
 */
enum ResultType {
	Place = "place",
	Locality = "locality",
	Street = "street",
	HouseNumber = "houseNumber",
	AdministrativeArea = "administrativeArea",
	AddressBlock = "addressBlock",
	Intersection = "intersection",
	PostalCodePoint = "postalCodePoint",
	ChainQuery = "chainQuery",
	CategoryQuery = "categoryQuery",
}

type DiscoverAddress = {
	label: string
}

const REGIONS = [ResultType.Locality, ResultType.AdministrativeArea, ResultType.AddressBlock] as const

export function isRegion(type: string): type is (typeof REGIONS)[number] {
	return REGIONS.includes(type as any)
}

export async function getSuggestions(
	searchQuery: string,
	mapCenter: { lng: number; lat: number },
	max: number = 10
): Promise<DiscoverResultItem[]> {
	const { lng, lat } = mapCenter
	const url = new URL(BASE_URL)

	url.searchParams.append("q", searchQuery)
	url.searchParams.append("at", `${lat},${lng}`)
	url.searchParams.append("limit", String(max))
	url.searchParams.append("in", "countryCode:CAN")
	url.searchParams.append("apiKey", API_KEY)

	return (await axios<DiscoverResult>(url.toString())).data.items
}
